<div class="pr-3 pl-4 h-full w-full overflow-auto">
  <div class="flex justify-between header-table" #pageOptionBtnGroup>
    <div class="title-page">
      <span class="title">Phân quyền chức năng&nbsp;</span>
      <breadcrumbs [items]="breadcrumbs"></breadcrumbs>
    </div>
    <div class="btn-option flex">
      <ng-container *ngIf="btnType === buttonTypeEnum.ICON">
        <button class="flex items-center justify-center" nz-button nzTooltipTitle="Lưu" (click)="save()"
          nzTooltipPlacement="bottom" nz-tooltip nzType="primary">
          <i nz-icon nzType="save" nzTheme="outline"></i>
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXT">
        <button class="flex items-center justify-center" nz-button nzType="primary" (click)="save()">
          Lưu
        </button>
      </ng-container>
      <ng-container *ngIf="btnType === buttonTypeEnum.TEXTANDICON">
        <button class="flex items-center justify-center" nz-button nzType="primary" (click)="save()">
          <i nz-icon nzType="save" nzTheme="outline"></i>Lưu
        </button>
      </ng-container>
    </div>
  </div>

  <div>
    <div nz-row [nzGutter]="[24,12]">
      <nz-card class="tree" nz-col nzSpan="6">
        <div nz-row [nzGutter]="[24,12]" class="tree">
          <!-- radio  -->
          <div nz-col nzSpan="24">
            <div nz-row [nzGutter]="[24,12]" class="group-radio">
              <ng-container *ngIf="isUser === false">
                <div nz-col nzSpan="24">
                  <h5 nz-typography>Bổ xung quyền mới</h5>
                  <nz-radio-group [(ngModel)]="selectedInheritanceRightsOption">
                    <label nz-radio [nzValue]="0">Không áp dụng</label>
                    <label nz-radio [nzValue]="1">Áp dụng toàn bộ cấp dưới</label>
                  </nz-radio-group>
                </div>
              </ng-container>
              <div nz-col nzSpan="24">
                <h5 nz-typography>Thu hồi quyền cũ</h5>
                <nz-radio-group [(ngModel)]="selectedAddNewPermissionsOption">
                  <label nz-radio [nzValue]="0">Không thu hồi</label>
                  <label nz-radio [nzValue]="1">Thu hồi tất cả</label>
                </nz-radio-group>
              </div>
            </div>
          </div>
          <nz-divider></nz-divider>
          <!-- Tìm kiếm -->
          <div nz-col nzSpan="24">
            <nz-input-group [nzSuffix]="suffixIcon">
              <input type="text" nz-input placeholder="Tìm kiếm" [(ngModel)]="searchValue" />
            </nz-input-group>
            <ng-template #suffixIcon>
              <i nz-icon nzType="search"></i>
            </ng-template>
          </div>
          <!-- tree -->
          <div nz-col nzSpan="24">
            <nz-tree nzBlockNode [nzData]="nodes" (nzClick)="activeNode($event)" (nzDblClick)="openFolder($event)"
              [nzTreeTemplate]="nzTreeTemplate" [nzSearchValue]="searchValue" (nzSearchValueChange)="nzEvent($event)"
              [nzSelectedKeys]="defaultSelectedKeys">
            </nz-tree>
            <ng-template #nzTreeTemplate let-node let-origin="origin">
              <span class="custom-node">
                <span *ngIf="!node.isLeaf" (contextmenu)="contextMenu($event, menu)">
                  <i nz-icon [nzType]="node.isExpanded ? 'group' : 'ungroup'" (click)="openFolder(node)"
                    nzTheme="outline"></i>
                  <span class="folder-name">{{ node.title }}</span>
                </span>
                <span *ngIf="node.isLeaf" (contextmenu)="contextMenu($event, menu)">
                  <i nz-icon nzType="user" nzTheme="outline"></i>
                  <span class="file-name">{{ node.title }}</span>
                </span>
              </span>
            </ng-template>
            <nz-dropdown-menu #menu="nzDropdownMenu">
            </nz-dropdown-menu>
          </div>
        </div>
      </nz-card>
      <div nz-col nzSpan="18" class="table">
        <nz-card>
          <nz-table 
            #expandTable 
            [nzData]="listOfMapData" 
            nzTableLayout="fixed" 
            [nzShowPagination]="false"
            [nzLoading]="settingValueLoading">
            <thead>
              <tr>
                <th class="text-left">Chức năng</th>
                <th class="text-center" nzWidth="110px">Xem</th>
                <th class="text-center" nzWidth="110px">Thêm mới</th>
                <th class="text-center" nzWidth="110px">Chỉnh sửa</th>
                <th class="text-center" nzWidth="110px">Xóa</th>
                <th class="text-center" nzWidth="140px">Tùy chọn</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let data of listOfMapData">
                <ng-container *ngFor="let item of mapOfExpandedData[data.screenId]">
                  <tr *ngIf="(item.parent && item.parent.expand) || !item.parent">
                    <td [nzIndentSize]="item.level! * 10" [nzShowExpand]="!!item.child" [(nzExpand)]="item.expand"
                      (nzExpandChange)="collapse(mapOfExpandedData[data.screenId], item, $event)">
                      {{ item.screenName }}
                    </td>
                    <td class="text-center">
                      <label *ngIf="item.allowReadVisible" nz-checkbox [(ngModel)]="item.allowRead"
                        (ngModelChange)="addToTreeSave(item, allowChange.AllowRead)">
                        Xem
                      </label>
                    </td>
                    <td class="text-center">
                      <label *ngIf="item.allowCreateVisible" nz-checkbox [(ngModel)]="item.allowCreate"
                        (ngModelChange)="addToTreeSave(item, allowChange.AllowCreate)">
                        Thêm
                      </label>
                    </td>
                    <td class="text-center">
                      <label *ngIf="item.allowUpdateVisible" nz-checkbox [(ngModel)]="item.allowUpdate"
                        (ngModelChange)="addToTreeSave(item, allowChange.AllowUpdate)">
                        Sửa
                      </label>
                    </td>
                    <td class="text-center">
                      <label *ngIf="item.allowDeleteVisible" nz-checkbox [(ngModel)]="item.allowDelete"
                        (ngModelChange)="addToTreeSave(item, allowChange.AllowDelete)">
                        Xóa
                      </label>
                    </td>
                    <td class="text-center">
                      <label *ngIf="item.allowCustomVisible" nz-checkbox [(ngModel)]="item.allowCustom"
                        (ngModelChange)="addToTreeSave(item, allowChange.AllowCustom)">
                        Tùy chọn
                      </label>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
            </tbody>
          </nz-table>
        </nz-card>
      </div>
    </div>
  </div>
</div>
